module.exports = __webpack_public_path__ + "static/img/xiyu1.89dc33ec.png";